export const sitePages = [
  {
    text: "Page d'accueil",
    value: "/",
  },
  {
    text: "Page A propos",
    value: "/apropos",
  },
  {
    text: "Page Contact",
    value: "/contact",
  },
];
